import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerInputFiled: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      gap: "32px",
    },
    titleInputFiled: {
      fontSize: "14px",
      fontWeight: "600",
      lineHeight: "20px",
      color: theme.palette.text.secondary,
      minWidth: "160px",
      maxWidth: "280px",
    },
    containerActivityRelatedToList: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
  };
});
